import { Community } from '@common/model/community';

export enum CommunityMode {
    Default = 'Default',
    RegistrationDisabled = 'RegistrationDisabled',
    Hidden = 'Hidden',
}

export class SpjpCommunity extends Community {
    communityMode: CommunityMode;
    isB2B: boolean;
    hideEpcPpa: boolean;
}
